import { Card as AntCard } from 'antd';
import { mapCurrency } from 'logic/currency/map-currency';
import { translate, translationKeys } from 'logic/translations/translations.service';
import React from 'react';
import { FC } from 'react';
import styled from 'styled-components';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';

interface SubscriptionCardProps {
  price: number;
  subscriptionString: string;
  subscriptionInterval: string;
  upTo: number | null;
  idx: number;
}

export const SubscriptionCard: FC<SubscriptionCardProps> = ({
  idx,
  price,
  subscriptionString,
  subscriptionInterval,
  upTo,
}) => {
  const { minTablet } = useBreakpoints();
  const isSingle = idx === 1;
  const isMiddle = idx === 2;
  const isLast = idx === 3;
  const currency = mapCurrency(subscriptionString);
  const interval = subscriptionInterval
    ? translate(
        translationKeys.tutoringInstituteProfile.subscriptions.interval[subscriptionInterval]
      )
    : '';

  return (
    <Card minTablet={minTablet} bordered={true}>
      {isSingle && (
        <Place>
          {translate(translationKeys.tutoringInstituteProfile.subscriptions.placeSingle)}
        </Place>
      )}
      {isMiddle && (
        <Place>
          {translate(translationKeys.tutoringInstituteProfile.subscriptions.placeSmallRange, {
            count: upTo,
          })}
        </Place>
      )}
      {isLast && (
        <Place>
          {translate(translationKeys.tutoringInstituteProfile.subscriptions.placeLargeRange, {
            count: upTo,
          })}
        </Place>
      )}
      <Price>
        {translate(translationKeys.tutoringInstituteProfile.subscriptions.price, {
          currency,
          price,
          interval,
        })}
      </Price>
      <PerLocation>
        {!isSingle && translate(translationKeys.tutoringInstituteProfile.subscriptions.perPlace)}
      </PerLocation>
      <DescriptionHeading>
        {translate(translationKeys.tutoringInstituteProfile.subscriptions.features.title)}
      </DescriptionHeading>
      <Features>
        <Feature>
          {translate(translationKeys.tutoringInstituteProfile.subscriptions.features.items1)}
        </Feature>
        <Feature>
          {translate(translationKeys.tutoringInstituteProfile.subscriptions.features.items2)}
        </Feature>
        <Feature>
          {translate(translationKeys.tutoringInstituteProfile.subscriptions.features.items3)}
        </Feature>
        <Feature>
          {translate(translationKeys.tutoringInstituteProfile.subscriptions.features.items4)}
        </Feature>
      </Features>
    </Card>
  );
};

const Card = styled(AntCard)<any>`
  flex: 1;
  min-height: 320px;
  margin-bottom: ${({ minTablet }) => (minTablet ? '0' : '48px')};
  .ant-card-body {
    padding: 20px 0;
  }
  &:not(:first-child) {
    margin-left: ${({ minTablet }) => (minTablet ? '20px' : '0')};
  }
`;

const Place = styled.div`
  font-size: 18px;
  text-align: center;
`;

const Price = styled.div`
  color: #2f4251;
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  margin: 10px;
`;

const PerLocation = styled.div`
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin: 10px;
  height: 25px;
`;

const DescriptionHeading = styled.div`
  font-size: 16px;
  text-align: center;
  margin-bottom: 12px;
`;

const Features = styled.ul`
  font-size: 14px;
  line-height: 24px;
  margin: 0 80px;
`;

const Feature = styled.li`
  font-size: 14px;
  line-height: 24px;
`;
